import { Box } from "@mui/material";
import { Panel } from "../components/layout/Panel";
import { UserProfileSettings } from "./settings/UserProfileSettings";

export function PageSettings() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Panel title="Settings" subtitle="Profile, password and sessions">
        <UserProfileSettings />
      </Panel>
    </Box>
  );
}
